import {Axios} from '../axios/axios'

export const getAdList = (data) => {
  return Axios({
    url:"/adminapi/getAdList",
    method:'POST',
    data: data
  })
}

export const updateAd= (data) => {
  return Axios({
    url:"/adminapi/editAd",
    method:'POST',
    data: data
  })
}